import { Directive, ElementRef, Input, OnInit } from '@angular/core';

declare var $: any;

@Directive({
  selector: '[appAnimate]'
})
export class AnimateNameDirective implements OnInit {
  @Input() private appAnimate: string;
  private delay: any = null;

  constructor(
    private el?: ElementRef
  ) {
    if (!this.el) {
      return;
    }

    $(this.el.nativeElement).css('opacity', '0');
  }

  ngOnInit() {
    if (!this.el) {
      return;
    }

    this.delay = $(this.el.nativeElement).attr('delay');
    this.delay ? this.renderWithDelay() : this.render();
  }

  render() {
    this.el.nativeElement.classList.add('animated');
    this.el.nativeElement.classList.add(this.appAnimate);
  }

  renderWithDelay() {
    const self = this;
    setTimeout(function() {
      self.render();
    }, this.delay);
  }
}



// WEBPACK FOOTER //
// ./src/app/shared/directives/animate-name/animate-name.directive.ts